<div id="qr-reader"></div>
@if (loading) {
  <ion-skeleton-text [animated]="true"></ion-skeleton-text>
}
